var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    width: 32,
    height: 32,
    fill: "currentColor",
    overflow: "hidden",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m727.27 437.33v261.33h-366.55v-261.33h366.55m0-37.333h-366.55c-22.482 0-40.727 16.688-40.727 37.333v261.33c0 20.645 18.246 37.333 40.727 37.333h366.55c22.522 0 40.727-16.688 40.727-37.333v-261.33c0-20.645-18.205-37.333-40.727-37.333zm20.364-74.667h-61.091v-18.667c0-10.304-9.1228-18.667-20.364-18.667-11.241 0-20.363 8.3627-20.363 18.667v18.667h-203.64v-18.667c0-10.304-9.1228-18.667-20.363-18.667-11.241 0-20.364 8.3627-20.364 18.667v18.667h-61.091c-11.241 0-20.364 8.3627-20.364 18.667s9.123 18.667 20.364 18.667h407.27c11.241 0 20.364-8.3627 20.364-18.667s-9.123-18.667-20.364-18.667zm-305.45 149.33h-40.727v37.333h40.727zm81.455 0h-40.727v37.333h40.727zm81.455 0h-40.727v37.333h40.727zm81.454 0h-40.727v37.333h40.727zm-244.36 74.667h-40.727v37.333h40.727zm81.455 0h-40.727v37.333h40.727zm81.455 0h-40.727v37.333h40.727zm81.454 0h-40.727v37.333h40.727zm-244.36 74.667h-40.727v37.333h40.727zm81.455 0h-40.727v37.333h40.727zm81.455 0h-40.727v37.333h40.727zm81.454 0h-40.727v37.333h40.727z",
    strokeWidth: 0.60928
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b56fd49d9a2f77747db0a5c033b10f6e.svg";
export { ForwardRef as ReactComponent };